// extracted by mini-css-extract-plugin
export default {"businessSSOTypeSelectLabel":"BusinessSSOTypeSelect_businessSSOTypeSelectLabel__wrtlG","businessSSOTypeSelectWrapper":"BusinessSSOTypeSelect_businessSSOTypeSelectWrapper__ZJq6D"};